import React from "react";
import LoaderTemplate from "../../component/LoaderTemplate";
import NoDataFound from "../../component/NoDataFound";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import ProjectList from "./ProjectListTile";
import { ListingLoaderTemplate } from "../../component/LoadersTemplate";

export default ({ projectList, isLoading }) => {
  return (
    <div>
      {isLoading === STATUS.LOADING ? (
        <LoaderTemplate
          parentClass="loader-project-list"
          times={10}
          height={65}
          children={<ListingLoaderTemplate />}
        />
      ) : isValidArray(projectList) ? (
        projectList.map((projectDTOS, index) => (
          <ProjectList project={projectDTOS} key={index} />
        ))
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
